import { z } from 'zod';
import { capacityCalendarSchema } from './capacity.js';
import { absenceCategorySchema, resourceSourcesSchema } from './integrations.js';
export const resourceDirectoryEntrySchema = z.object({
    id: z.uuid(),
    name: z.string(),
    active: z.boolean(),
    primaryExpertise: z.object({ id: z.uuid(), name: z.string() }).nullable(),
    tempoTeams: z.array(z.object({ id: z.string(), name: z.string() })),
    businessSquads: z.array(z.object({ id: z.uuid(), name: z.string() })).optional(),
});
export const resourcesResponseSchema = z.object({
    data: z.array(resourceDirectoryEntrySchema),
    meta: resourceSourcesSchema,
});
export const resourceTicketSchema = z.object({
    id: z.uuid(),
    key: z.string(),
    title: z.string(),
    status: z.string(),
    projectId: z.uuid(),
    projectName: z.string(),
    remainingMinutes: z.number().int().nonnegative().nullable(),
    startDate: z.iso.date().nullable(),
    dueDate: z.iso.date().nullable(),
    sourceUpdatedAt: z.iso.datetime().nullable(),
});
export const resourceAbsenceSchema = z.object({
    id: z.uuid(),
    date: z.iso.date(),
    minutes: z.number().int().nonnegative(),
    category: absenceCategorySchema,
    source: z.enum(['tempo', 'local']),
    ticketKey: z.string().nullable().optional(),
    label: z.string().nullable().optional(),
});
export const resourceProfileResponseSchema = z.object({
    data: z.object({
        resource: resourceDirectoryEntrySchema,
        canReadWorkforce: z.boolean(),
        capacity: capacityCalendarSchema.nullable(),
        tickets: z.object({
            items: z.array(resourceTicketSchema),
            total: z.number().int().nonnegative(),
            page: z.number().int().positive(),
            pageSize: z.number().int().positive(),
        }),
        absences: z.object({
            items: z.array(resourceAbsenceSchema),
            available: z.boolean().nullable(),
        }),
    }),
    meta: resourceSourcesSchema,
});
//# sourceMappingURL=resources.js.map